export default __webpack_public_path__ + "static/media/arrowRight.1406dbce.svg";